var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.previewClass,attrs:{"id":"videoPreview2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }